import script from "./SegmentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentPage.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentPage.vue?vue&type=style&index=0&id=07343623&lang=scss"

const __exports__ = script;

export default __exports__